var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatacalculationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rules") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    d: "M32.21,53.402c0.55-0.563,1.452-0.572,2.014-0.021c0.007,0.007,0.014,0.014,0.021,0.021 c0.564,0.57,0.564,1.488,0,2.059l-2.441,2.49l2.441,2.49c0.564,0.563,0.564,1.479,0,2.043c-0.564,0.563-1.479,0.563-2.042,0 l-2.441-2.441l-2.441,2.441c-0.55,0.561-1.452,0.57-2.014,0.02c-0.007-0.006-0.014-0.014-0.021-0.02 c-0.559-0.573-0.559-1.487,0-2.06l2.441-2.49l-2.441-2.49c-0.562-0.565-0.562-1.478,0-2.042c0.549-0.559,1.445-0.564,2.002-0.017 c0.005,0.005,0.011,0.011,0.016,0.017l2.441,2.441l2.441-2.441H32.21z M31.087,17.904c-1.725-0.035-3.112-1.432-3.133-3.158V13.68 H14.697c-0.263,0.012-0.472,0.225-0.48,0.488v81.144c0.004,0.264,0.217,0.476,0.48,0.48h70.605c0.264-0.005,0.476-0.217,0.48-0.48 V14.168c-0.013-0.26-0.221-0.468-0.48-0.48H72.33v1.066c-0.025,1.731-1.426,3.127-3.156,3.149H31.087z M14.73,100 c-2.583-0.004-4.675-2.097-4.68-4.68V14.168c0.004-2.583,2.097-4.675,4.68-4.68h13.224V8.496c0.009-1.748,1.426-3.161,3.174-3.166 h5.631V3.5c0.026-1.918,1.573-3.469,3.491-3.5h19.531c1.92,0.03,3.47,1.58,3.5,3.5v1.839h5.852 c1.744,0.009,3.156,1.421,3.166,3.166v0.993H85.27c2.583,0.004,4.676,2.097,4.68,4.679V95.32c-0.004,2.583-2.097,4.676-4.68,4.68 H14.73z M73.682,80.607c1.168-0.002,2.115-0.949,2.113-2.118c-0.001-1.167-0.946-2.112-2.113-2.114H45.508 c-1.168-0.001-2.117,0.945-2.118,2.114c-0.001,1.169,0.945,2.116,2.114,2.118c0.001,0,0.003,0,0.004,0H73.682z M73.682,39.917 c1.168,0,2.115-0.947,2.115-2.116c0-1.169-0.947-2.116-2.115-2.116H45.508c-1.168,0-2.116,0.947-2.116,2.116 c0,1.168,0.947,2.116,2.116,2.116l0,0H73.682z M73.682,59.969c1.168,0.002,2.117-0.945,2.118-2.113s-0.945-2.117-2.114-2.118 c-0.001,0-0.002,0-0.004,0H45.508c-1.168-0.001-2.117,0.945-2.118,2.114c-0.001,1.168,0.945,2.116,2.114,2.117 c0.001,0,0.003,0,0.004,0H73.682z M25.375,78.377c-0.578-0.863-0.346-2.03,0.517-2.607c0.863-0.578,2.031-0.347,2.608,0.516l0,0 l1.025,1.522l4.069-4.94c0.656-0.799,1.837-0.916,2.637-0.26s0.917,1.837,0.26,2.637l-5.615,6.836 c-0.126,0.163-0.277,0.306-0.447,0.424c-0.861,0.575-2.026,0.346-2.604-0.514l-2.441-3.613H25.375z M25.887,37.223 c0.863-0.576,2.03-0.347,2.612,0.513l1.025,1.522l4.069-4.94c0.656-0.8,1.837-0.917,2.637-0.26s0.917,1.837,0.26,2.637 l-5.615,6.836c-0.137,0.163-0.299,0.303-0.48,0.415c-0.861,0.576-2.025,0.347-2.604-0.513l-2.441-3.613l0,0 c-0.576-0.861-0.347-2.025,0.513-2.604L25.887,37.223z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M63.363,93.425H13.82c-3.701,0-6.712-3.396-6.712-7.572V13.248c0-4.175,3.012-7.573,6.712-7.573h53.265 c3.703,0,6.711,3.397,6.711,7.573v63.299h-3.51V13.248c0-2.241-1.434-4.063-3.201-4.063H13.82c-1.765,0-3.202,1.824-3.202,4.063 v72.601c0,2.24,1.437,4.064,3.202,4.064h49.543V93.425z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M63.365,35.554H17.537V19.09h45.828V35.554z M21.047,32.043h38.809V22.6H21.047V32.043z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M71.952,95.434c-11.661,0-21.148-9.488-21.148-21.149c0-6.006,2.566-11.747,7.044-15.757 c3.88-3.477,8.89-5.393,14.104-5.393c11.661,0,21.149,9.488,21.149,21.149S83.613,95.434,71.952,95.434z M71.952,56.645 c-4.35,0-8.527,1.598-11.764,4.498c-3.733,3.344-5.875,8.134-5.875,13.142c0,9.726,7.912,17.64,17.639,17.64 c9.726,0,17.64-7.914,17.64-17.64C89.592,64.558,81.678,56.645,71.952,56.645z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.197,
    y: 54.89,
    fill: "#231F20",
    width: 3.51,
    height: 19.395
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.349,
    y: 71.447,
    transform: "matrix(-0.7072 -0.707 0.707 -0.7072 53.7921 184.5379)",
    fill: "#231F20",
    width: 3.51,
    height: 19.369
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.196,
    y: 79.183,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 76.9598 193.7528)",
    fill: "#231F20",
    width: 18.823,
    height: 3.509
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 19.292,
    y: 44.653,
    fill: "#231F20",
    width: 18.935,
    height: 7.021
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 19.292,
    y: 63.956,
    fill: "#231F20",
    width: 18.935,
    height: 7.021
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M64.553,67.466"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 45.618,
    y: 63.956,
    fill: "#231F20",
    width: 6.355,
    height: 7.021
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 43.863,
    y: 44.653,
    fill: "#231F20",
    width: 18.934,
    height: 7.021
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatacalculationIcon);
export default __webpack_public_path__ + "static/media/datacalculationIcon.662947f2.svg";
export { ForwardRef as ReactComponent };